export default __webpack_public_path__ + "static/media/exit.f7f4c043.png";